module.exports = __webpack_public_path__ + "img/bottom-banner-cloud.f4df62d5.png";